module.exports = __webpack_public_path__ + "static/media/water-rise.d73656a2.svg";